import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons/faBuilding';
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons/faFileAlt';
import { useLocation } from 'react-router-dom';

import Tooltip from '../../../Tooltip';
import BetaTag from '../../../Shared/BetaTag';
import NewTag from '../../../Shared/NewTag';

import useSizes from '../../../../hooks/sizes';
import InsiderSvc from '../../../../services/dbServices/InsiderSvc';
import { setUKPrivateCompanyHideAbnormal } from '../../../../actions/ukPrivateCompany.actions';

import Styles from './styles.module.scss';

const Header = (props) => {
  const {
    title,
    showSub,
    tooltipText,
    showAbnormal,
    natureOfBusinessTitle,
  } = props;
  const { pathname } = useLocation();

  const { width } = useSizes();
  const [coverageData, setCoverageData] = useState({
    loading: true,
    companiesCovered: 0,
    filingsExtracted: 0,
  });
  const hideAbnormal = useSelector(({ ukPrivateCompany }) => (
    ukPrivateCompany.hideAbnormal
  ));
  const dispatch = useDispatch();

  const handleAbnormalClick = () => {
    dispatch(setUKPrivateCompanyHideAbnormal(!hideAbnormal));
  };

  const convertNumber = (dataChk) => {
    let divider = 1;
    let prefix = '';
    if (dataChk >= 1000000000000000) {
      divider = 1000000000000000;
      prefix = 'quadrillion';
    } else if (dataChk >= 1000000000000) {
      divider = 1000000000000;
      prefix = 'trillion';
    } else if (dataChk >= 1000000000) {
      divider = 1000000000;
      prefix = 'billion';
    } else if (dataChk < 1000000000 && dataChk >= 1000) {
      divider = 1000000;
      prefix = 'million';
    }

    if (prefix) {
      return `${(dataChk / divider).toFixed(2)} ${prefix}`;
    }
    return dataChk;
  };

  useEffect(() => {
    let mounted = true;

    InsiderSvc.getCompanyInsiderCoverage()
      .then((data) => {
        if (!mounted) {
          return;
        }

        setCoverageData({
          loading: false,
          companiesCovered: convertNumber(data?.companiesCovered || 0),
          filingsExtracted: convertNumber(data?.filingsExtracted || 0),
        });
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <>
      <div className={Styles['uk-private-company-header']}>
        <div className={Styles['uk-private-company-title']}>
          <div className={Styles['uk-private-company-title-holder']}>
            <div className={Styles['uk-private-company-title-text']}>
              {title}
            </div>
            {tooltipText && (
              <Tooltip
                newIcon
                hasBigScreenDesign
                isCentered
                dynamicPosition
                contentStyle={{ left: 0 }}
                className={Styles['uk-private-company-title-tooltip']}
              >
                {tooltipText}
              </Tooltip>
            )}
            <BetaTag className={Styles['uk-private-company-beta']} />
            <NewTag className={Styles['uk-private-company-new']} />
          </div>
          {natureOfBusinessTitle && (
            <div className={Styles['uk-private-company-title-sector']}>
              Sector:
              {' '}
              {natureOfBusinessTitle}
            </div>
          )}
        </div>
        {showSub && width > 1024 && !coverageData.loading && (
          <div className={Styles['uk-private-company-header-right']}>
            <div className={Styles['uk-private-company-header-sub']}>
              <FontAwesomeIcon icon={faBuilding} />
              COMPANIES COVERED
              <div className={Styles['uk-private-company-header-sub-bold']}>
                {coverageData.companiesCovered}
              </div>
            </div>
            <div className={Styles['uk-private-company-header-sub']}>
              <FontAwesomeIcon icon={faFileAlt} />
              FILINGS ANALYSED
              <div className={Styles['uk-private-company-header-sub-bold']}>
                {coverageData.filingsExtracted}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className={Styles['uk-private-company-header-note']}>
        Data is machine-extracted. Please verify before making any decisions.
        <Tooltip
          newIcon
          hasBigScreenDesign
          isCentered
          dynamicPosition
          contentStyle={{ left: 0 }}
          className={Styles['uk-private-company-header-note-tooltip']}
        >
          The data presented here is automatically extracted from the relevant documents
          filled by the companies. Some data may be inaccurately extracted.
          Accuracy and completeness should be verified before making decisions.
          {' '}
          <a href="/contact-us" rel="noreferrer">
            Contact us
          </a>
          {' '}
          to notify us of errors and concerns.
        </Tooltip>
        {/* {showAbnormal && width > 767 && (
          <div className={Styles['uk-private-company-abnormal']}>
            <FontAwesomeIcon
              icon={hideAbnormal ? faCheckSquare : faSquare}
              onClick={handleAbnormalClick}
            />
            <div className={Styles['uk-private-company-abnormal-text']}>
              Hide abnormal transactions.
            </div>
            <Tooltip
              newIcon
              hasBigScreenDesign
              className={Styles['uk-private-company-abnormal-tooltip']}
            >
              Hide abnormal transactions.
            </Tooltip>
          </div>
        )} */}
      </div>
      {showSub && width <= 1024 && !coverageData.loading && (
        <div className={Styles['uk-private-company-header-right']}>
          <div className={Styles['uk-private-company-header-sub']}>
            <FontAwesomeIcon icon={faBuilding} />
            COMPANIES COVERED
            <div className={Styles['uk-private-company-header-sub-bold']}>
              {coverageData.companiesCovered}
            </div>
          </div>
          <div className={Styles['uk-private-company-header-sub']}>
            <FontAwesomeIcon icon={faFileAlt} />
            FILINGS ANALYSED
            <div className={Styles['uk-private-company-header-sub-bold']}>
              {coverageData.filingsExtracted}
            </div>
          </div>
        </div>
      )}
      {/* {showAbnormal && width <= 767 && (
        <div className={Styles['uk-private-company-abnormal']}>
          <FontAwesomeIcon
            icon={hideAbnormal ? faCheckSquare : faSquare}
            onClick={handleAbnormalClick}
          />
          <div className={Styles['uk-private-company-abnormal-text']}>
            Hide abnormal transactions.
          </div>
          <Tooltip
            newIcon
            hasBigScreenDesign
            className={Styles['uk-private-company-abnormal-tooltip']}
          >
            Hide abnormal transactions.
          </Tooltip>
        </div>
      )} */}
    </>
  );
};

export default Header;
